// The outcome a result carries before it has finished. An uploaded
// conversation keeps its recording from the moment it is queued, and its
// transcript is written only once processing ends.
const PROCESSING_STATUSES = new Set([
  "IN QUEUE",
  "QUEUED",
  "PENDING",
  "IN PROGRESS",
  "RUNNING",
])

/**
 * What a result's recording player says about the transcript that goes with
 * it: nothing while there is one, that it is on its way while the result is
 * still being processed, and that there is none once processing has ended
 * without one.
 */
export function recordingTranscriptNotice(row: {
  transcript?: readonly unknown[] | null
  error_status?: string | null
}): string | null {
  if (row.transcript?.length) {
    return null
  }
  const status = (row.error_status ?? "")
    .replace(/_/g, " ")
    .trim()
    .toUpperCase()
  return PROCESSING_STATUSES.has(status)
    ? "Transcript not ready yet"
    : "No transcript for this recording"
}
